import { GridItem, PageGrid, Text, Box, Heading, RichText } from '@ads-core/components';

type ErrorsProps = {
  title?: string;
  text?: string;
};

export const ErrorMessage = ({ title, text }: ErrorsProps) => {
  return (
    <PageGrid>
      <GridItem columnStart="1" columnEnd="-1">
        <Text align="center" asChild>
          <Box paddingBlock={10} width="100%">
            {title ? (
              <Box paddingBottom={3} asChild>
                <Heading size="h2" align="center">
                  {title}
                </Heading>
              </Box>
            ) : null}
            {text ? <RichText>{text}</RichText> : null}
          </Box>
        </Text>
      </GridItem>
    </PageGrid>
  );
};
